<template>


<div class="page-content" data-test-key="home-page">

  <SeoMeta 
    :title="'TheJobTap.com - Explore AI and Blockchain jobs'" 
    :description="'TheJobTap.com is advertising the latest jobs from leading and growing Blockchain and AI companies, find great industry opportunities and boost your career.'"
    />

  <section class="pt-28 lg:pt-44 pb-28 group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 dark:bg-neutral-900 bg-[url('../images/home/page-title.png')] bg-center bg-cover relative" >
    <div class="container mx-auto">
        <div class="grid">
            <div class="col-span-12">
                <div class="text-center text-white">
                    <h1 class="mb-4 text-[26px]">Search AI, Web3, and Emerging Tech Jobs</h1>
                    <div class="page-next">
                      <p>Explore <span v-if="!pageLoading">{{Number(this.jobListingResultCount).toLocaleString()}}+</span> AI and Web3 jobs, updated daily, and find opportunities that match your skills and career goals.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
            <img rel="prefetch" src="@/assets/images/about/shape.png" alt="header image" class="absolute block bg-cover -bottom-0 dark:hidden" style="width: 100%;">
            <img rel="prefetch" src="@/assets/images/about/shape-dark.png" alt="header image dark" class="absolute hidden bg-cover -bottom-0 dark:block" style="width: 100%;">
  </section>

<section class="py-16" style="padding-bottom: 0px!important;" v-if="pageLoading">
    <div class="container mx-auto">
        <div class="grid grid-cols-12 xl:gap-10 gap-y-12">
            <div class="col-span-12 xl:col-span-12">
              <Loader style="margin-bottom: 300px!important;"/>
            </div>
        </div>
    </div>
</section>

<span id="searchHint"></span>

<section class="py-10" style="padding-bottom: 0px!important;" v-if="!pageLoading">

  <div class="container relative mx-auto">
    <div class="grid items-center grid-cols-12 rtl:gap-10">
        <div class="col-span-12">

                    <div class="grid grid-cols-12">
                      <div class="col-span-12 xl:col-span-3">
                      </div>
                        <div class="col-span-12 xl:col-span-3" style="margin-right: 2px; margin-left: 2px;">
                           <div class="relative filler-job-form mt-3">
                              <input 
                                id="_searchTermInput"
                                v-on:keydown.enter.prevent="handleSearchTermInput(search.keywords);"
                                @blur="handleSearchTermInput(search.keywords);" 
                                v-model="search.keywords"
                                style="float: right; height: 2.75rem;"
                                class="w-full rounded placeholder:text-sm border-gray-100/50 dark:bg-transparent dark:border-gray-800 dark:text-gray-100" 
                                type="text" 
                                placeholder="Search by job title or location" />
                              <a 
                                class="absolute rounded top-3 ltr:right-4 rtl:left-4" 
                                @click.stop="handleSearchTermInput(search.keywords)">
                                <span class="text-gray-500 mdi mdi-magnify"></span>
                              </a>
                            </div>
                        </div>
                        <div class="col-span-12 xl:col-span-3"  style="margin-right: 2px; margin-left: 2px;">
                            <div class="mt-3 filter-search-form mt-lg-0">
                                <i class="uil uil-clipboard-notes"></i>
                                <select 
                                v-model="this.search.workingStyle" 
                                v-on:change="this.handleJobListingSearch(true, 'searchHint')"  
                                style=""
                                class="w-full filter-job-input-box dark:text-gray-100">
                                    <option value=null>Working style</option>
                                    <option value="Remote">Remote</option>
                                    <option value="Hybrid">Hybrid</option>
                                    <option value="Office">Office</option>
                                </select>
                            </div>
                        </div><!--end col-->
                        <div class="col-span-12 xl:col-span-3">
                        </div>

                    </div>
        </div>
    </div>
</div>

        <div class="container mx-auto">
            <div class="grid grid-cols-12 xl:gap-10 gap-y-12">
                <div class="col-span-12 xl:col-span-12">
 
                    <div class="mt-8" v-if="!pageLoading">
                        <!-- <h6 class="mb-4 text-gray-900 dark:text-gray-50 ">
                          Skills : Group by [tech non-tech]
                          <span class="px-2 py-1 rounded text-11 ltr:float-right rtl:float-left">
                            found {{ this.jobListingResultCount }}
                          </span>
                        </h6> -->
                      <!-- Search: Tags -->
                        <ul class="flex flex-wrap gap-2">
                          <li :class="{ active: this.search.tags == '' }" class="border p-[6px] border-gray-100/50 rounded group/joblist dark:border-gray-100/20">
                            <div class="flex items-center">
                              <!-- <div class="px-2 py-1 rounded text-11">
                                  {{ this.jobListingResultCount }} 
                              </div>  -->
                              <a href="javascript:void(0)"
                              class="text-gray-900 dark:text-gray-50" 
                                v-on:click="handleCategoryClick(null, 'searchHint')"
                                style="cursor:pointer;">
                                  <h6 class="mb-0 transition-all duration-300 fs-14 group-data-[theme-color=violet]:group-hover/joblist:text-violet-500 group-data-[theme-color=blue]:group-hover/joblist:text-blue-500">
                                    All
                                  </h6>
                              </a>
                            </div>
                          </li>
                          <li 
                            :class="{ active: search.tags.includes(jobListingCategory.Name) }"
                            class="border p-[6px] border-gray-100/50 rounded group/joblist dark:border-gray-100/20 " 
                            v-bind:key="jobListingCategory.Name" 
                            v-for="jobListingCategory in jobListingCategories" >
                            <div class="flex items-center" v-if="jobListingCategory.JobListingCount > 0">
                              <!-- <div class="text-center group-data-[theme-color=violet]:bg-violet-500/20 group-data-[theme-color=blue]:text-blue-500 text-sm font-medium">
                                        {{jobListingCategory.JobListingCount}}
                                    </div> -->
                                    <a href="javascript:void(0)" 
                                    class="text-gray-900 dark:text-gray-50" 
                                    style = "cursor:pointer;"
                                    v-on:click="handleCategoryClick(jobListingCategory.Name)" >
                                        <h6 class="mb-0 transition-all duration-300 fs-14 group-data-[theme-color=violet]:group-hover/joblist:text-violet-500 group-data-[theme-color=blue]:group-hover/joblist:text-blue-500">
                                          {{ jobListingCategory.Name }}
                                        </h6>
                                    </a>
                                </div>
                          </li>
                             <span id="searchResultsHint"></span>
                        </ul>
                    </div>

                    <ul class="flex flex-wrap gap-2 text-gray-700 dark:text-gray-50" v-if="search.location != '' || search.companyName != '' || search.contractType != ''" style="margin-bottom: 15px; margin-top: 15px;">
                      <li style="display:inline-block;" 
                        v-if="this.search.location != null && location != []">
                        <span 
                          class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50 active"  
                          style="cursor:pointer;"
                          v-on:click="handleLocationClick(null)"
                          >
                          <i class="uil uil-search"></i> 
                          <a> location: {{ this.search.location }} X</a>
                          </span>
                      </li>                                        
                      <li style="display:inline-block;" 
                      v-if="this.search.companyName != null">
                        <span 
                          class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50 active"  
                          style="cursor:pointer;"
                          v-on:click="handleCompanyNameClick(null)"
                          >
                          <i class="uil uil-search"></i> 
                          <a> company: {{ this.search.companyName }} X</a>
                          </span>
                      </li>                                        
                      <li style="display:inline-block;" 
                      v-if="this.search.contractType != null">
                        <span 
                          class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50 active"  
                          style="cursor:pointer;"
                          v-on:click="handleContractTypeClick(null)"
                          >
                          <i class="uil uil-search"></i> 
                          <a> contract type: {{ this.search.contractType == "FullTime" ? "full-time" : this.search.contractType }} X</a>
                          </span>
                      </li>          
                      <!-- <li style="display:inline-block;" 
                        v-if="this.search.workingStyle != null">
                          <span 
                            class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50 active"  
                            style="cursor:pointer;"
                            v-on:click="handleContractTypeClick(null)"
                            >
                            <i class="uil uil-search"></i> 
                            <a> working style: {{ this.search.workingStyle }} X</a>
                            </span>
                      </li>                                -->
                      <li style="display:inline-block;" 
                      v-if="this.search.keywords != null">
                        <span 
                          class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50 active"  
                          style="cursor:pointer;"
                          v-on:click="handleSearchTermInput(null)"
                          >
                          <i class="uil uil-search"></i> 
                          <a> keywords: {{ this.search.keywords }} X</a>
                          </span>
                      </li>                                        
                  </ul>  

                </div>
            </div>
        </div>
    </section>


  <!-- start job list -->
  <section class="py-2 dark:bg-neutral-700 bg-opacity-10" v-if="!pageLoading">
          <div class="container mx-auto">
            <div class="grid grid-cols-12 xl:gap-10 gap-y-12">
              <div class="col-span-12 xl:col-span-12 ">
                <div id="search" class="job-list-header mt-2">
                  <div class="grid grid-cols-12 gap-4">
                    <div class="hidden lg:block col-span-12 xl:col-span-4">
                      <div style="line-height:44.5px;">
                      <span v-if="!jobListingsLoading" style=""
                          class="text-gray-900 text-16 dark:text-gray-50">Found {{ Number(this.jobListingResultCount).toLocaleString() }} jobs
                      </span>
                      <span v-else style=""
                          class="text-gray-900 text-16 dark:text-gray-50">Loading...
                      </span>
                    </div> 
                    </div>
                    <div class="col-span-12 xl:col-span-4">
                      <EmailSubscriptionForm 
                        v-if="!jobListingsLoading"
                        class="text-center"
                        :handleResetForm="this.resetEmailForm"
                        :attendanceRequirement=this.search.workingStyle
                        :companyName=this.search.companyName
                        :tags=this.search.tags
                        :location=null
                        :contractType=this.search.contractType
                        :minSalary=null>
                      </EmailSubscriptionForm>
                    </div>
                    <div class="col-span-12 xl:col-span-4"  style="line-height:44.5px;">

                      <select 
                          style="float: right; min-width: 170px; margin-right:0px;"
                          class="block filter-job-input-box dark:text-gray-100 sm:w-50" 
                          v-model="search.sortOrder" @change="handleSortOrderOnChange($event)">
                        <option v-if="this.search.sortOrder == null" :value="null">{{ this.defaultSortOrder[1] }}</option>
                        <option v-else :value="this.defaultSortOrder[0]">{{ this.defaultSortOrder[1] }}</option>
                        <option v-bind:key="sortOrderType" v-for="sortOrderType in sortOrders" :value="sortOrderType[0]">{{ sortOrderType[1] }}</option>
                      </select> 
                      <span v-if="!jobListingsLoading" style=""
                          class="lg:hidden block text-gray-900 text-16 dark:text-gray-50">Found {{ Number(this.jobListingResultCount).toLocaleString() }} jobs
                      </span> 
                      <span v-else style=""
                          class="lg:hidden block text-gray-900 text-16 dark:text-gray-50">Loading...
                      </span> 
                    </div>
                  </div>
                </div>
              </div>
            </div>

                  <div class="block w-full tab-pane" id="recent-job">
                      <div>
                          <div class="space-y-8">
                            <FeedbackNotification style="margin-bottom: 15px;" 
                              v-if="this.notification.text != ''" 
                              :feedbackText="this.notification.text" 
                              :feedbackLevel="this.notification.level"/>

                              <div v-if="jobListingsLoading" class="mt-10">
                                  <!-- <div class="animate-spin inline-block w-8 h-8 border-[3px] border-l-transparent border-violet-500 rounded-full"></div> -->
                                  <Loader style="margin-bottom: 800px!important;"/>
                              </div> 
                              <div v-else-if="jobListings != ''">

                                <div v-bind:key="jobListing.Identifier" :id="jobListing.Identifier" v-for="jobListing in jobListings" 
                                  class="relative mt-4 overflow-hidden transition-all duration-500 ease-in-out bg-white border rounded-md border-gray-100/50 group/jobs group-data-[theme-color=violet]:hover:border-violet-500 group-data-[theme-color=blue]:hover:border-blue-500 hover:-translate-y-2 dark:bg-neutral-900 dark:border-neutral-600 ">
                                  <!-- FEATURED STAR-->
                                  <!-- <div class="w-48 absolute -top-[5px] -left-20 -rotate-45 group-data-[theme-color=violet]:bg-violet-500/20 group-data-[theme-color=blue]:bg-blue-500/20 group-data-[theme-color=violet]:group-hover/jobs:bg-violet-500 group-data-[theme-color=sky]:group-hover/jobs:bg-sky-500 group-data-[theme-color=red]:group-hover/jobs:bg-red-500 group-data-[theme-color=green]:group-hover/jobs:bg-green-500 group-data-[theme-color=pink]:group-hover/jobs:bg-pink-500 group-data-[theme-color=blue]:group-hover/jobs:bg-blue-500 transition-all duration-500 ease-in-out p-[6px] text-center dark:bg-violet-500/20">
                                          <a href="javascript:void(0)" class="text-2xl text-white align-middle"><i class="mdi mdi-star"></i></a>
                                  </div>
                                    -->
                                      <div class="p-4">
                                          <div class="grid items-center grid-cols-12">
                                              <div class="col-span-12 lg:col-span-2">
                                                  <div class="mb-4 text-center mb-md-0">
                                                    <router-link 
                                                      :to="'/hiring-companies/' + jobListing.CompanyName + '/' + jobListing.Identifier"> 
                                                      
                                                      <img 
                                                        v-lazy="jobListing.CompanyLogoReference + '/public'"
                                                        :alt="jobListing.CompanyName + ' logo'" 
                                                        width="100px" 
                                                        class="mx-auto img-fluid rounded-3">
                                                    
                                                    </router-link>

                                                  </div>
                                              </div>
                                              <!-- <div class="col-span-12 lg:col-span-1">
                                                  <div class="mb-4 text-center mb-md-0">
                                                  </div>
                                              </div>  -->
                                              <!--end col-->
                                              <div class="col-span-12 lg:col-span-4" style="padding-right: 5px;">
                                                  <div class="mb-2 mb-md-0">
                                                      <h5 class="mb-1 fs-18">
                                                          <router-link 
                                                              :to="'/hiring-companies/' + jobListing.CompanyName + '/' + jobListing.Identifier" 
                                                              class="text-gray-900 dark:text-gray-50"> {{ jobListing.Title }} </router-link>
                                                      </h5>
                                                      <p 
                                                      class="mb-0 text-gray-500 fs-14 dark:text-gray-120"
                                                      :class="{ 
                                                            'text-violet-500 dark:text-violet-500': this.search.companyName != '' && this.search.companyName != null
                                                            }"
                                                        style="cursor: pointer;" 
                                                        v-on:click="handleCompanyNameClick(jobListing.CompanyName)">{{ jobListing.CompanyName }}</p>
                                                  </div>
                                              </div>
                                              <!--end col-->
                                              <div class="col-span-12 lg:col-span-2" style="padding-right: 5px;">
                                                  <div class="mb-2 lg:flex">
                                                      <div class="flex-shrink-0" style="float:left;">
                                                          <i v-if="jobListing.Location  && jobListing.Location != ' '" 
                                                          class="mr-1 group-data-[theme-color=violet]:text-violet-500 group-data-[theme-color=blue]:text-blue-500 mdi mdi-map-marker"></i>
                                                      </div>
                                                      <p 
                                                        class="mb-0 text-gray-500 dark:text-gray-120"
                                                        :class="{ 
                                                            'text-violet-500 dark:text-violet-500': this.search.location != '' && this.search.location != null
                                                            }"
                                                        >{{ jobListing.Location }}
                                                      </p>
                                                      <!--  style="cursor: pointer;"  v-on:click="handleLocationClick(jobListing.Location)" -->
                                                  </div>
                                              </div>
                                              
                                              <!--end col-->
                                              <div class="col-span-12 lg:col-span-2">
                                                  <div v-if="jobListing.Salary.From > 0">
                                                      <p class="mb-2 text-gray-500 dark:text-gray-120">
                                                          <span class="group-data-[theme-color=violet]:text-violet-500 group-data-[theme-color=blue]:text-blue-500">
                                                              </span>{{ jobListing.Salary.From.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }) }} - {{ jobListing.Salary.To.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0}) }}</p>
                                                  </div>
                                              </div>
                                              <!--end col-->
                                              <div class="col-span-12 lg:col-span-2">
                                                  <div class="flex flex-wrap gap-1.5">
                                                      <span 
                                                        style="cursor: pointer;" 
                                                        v-on:click="handleIsRemoteClick(jobListing.AttendanceRequirement, 'searchResultsHint');"
                                                        v-if="jobListing.AttendanceRequirement != 'NotSet'"
                                                            :class="
                                                                  { 
                                                                  'active': this.search.workingStyle != '' && this.search.workingStyle != null
                                                                  }"
                                                          class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50">
                                                          {{ jobListing.AttendanceRequirement }}
                                                      </span>
                                                      <span 
                                                        style="cursor: pointer;" 
                                                        v-if="jobListing.ContractType != 'NotSet'"
                                                        v-on:click="handleContractTypeClick(jobListing.ContractType);"
                                                        :class="
                                                                  { 
                                                                  'active': this.search.contractType != '' && this.search.contractType != null
                                                                  }"
                                                          class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50">
                                                          {{ jobListing.ContractType == "FullTime" ? "Full-time" : jobListing.ContractType }}
                                                      </span>
                                                  </div>
                                              </div>
                                              <!--end col-->
                                          </div>
                                          <!--end row-->
                                      </div>
                                      <div class="bg-gray-50 dark:bg-neutral-700">
                                          <div class="grid grid-cols-12">
                                              <div class="col-span-12 lg:col-span-10 p-3 ">
                                                  <div>
                                                    <ul class="flex flex-wrap gap-2 text-gray-700 dark:text-gray-50">
                                                              <!-- <li><i class="uil uil-tag"></i> Skills :</li> -->
                                                              <li><i class="uil uil-tag"></i></li>
                                                              <li style="display:inline-block;" v-bind:key="categoryName" v-for="categoryName in jobListing.CategoryNames" >
                                                              <span 
                                                                  class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50"  
                                                                  style="cursor:pointer;"
                                                                  :class="
                                                                  { 
                                                                  'active': search.tags.includes(categoryName),  
                                                                  }" 
                                                                    v-on:click="handleCategoryClick(categoryName, 'searchResultsHint')"
                                                                  >
                                                                  <a>{{ categoryName }}</a>
                                                                  </span>
                                                              </li>                                        
                                                          </ul>   
                                                  </div>
                                              </div>
                                              <!--end col-->
                                              <div class="col-span-12 lg:col-span-2 p-2 ">
                                                  <div class="text-start text-md-end text-gray-700 dark:text-gray-50">
                                                    <a v-if="showMoreJobListing == null || showMoreJobListing?.Identifier != jobListing.Identifier" style="cursor: pointer; float:right;" 
                                                      @click.stop="handleJobListingShowMoreClick(jobListing.Identifier, this)">scan 
                                                      <i class="mdi mdi-chevron-double-down"></i>
                                                    </a>
                                                    <a v-if="showMoreJobListing != null && showMoreJobListing?.Identifier == jobListing.Identifier" style="cursor: pointer; float:right;" 
                                                      @click.stop="handleJobListingShowMoreClick(jobListing.Identifier, this)">minimise 
                                                      <i  class="mdi mdi-chevron-double-up"></i>
                                                    </a>
                                                  <!-- <div 
                                                    style="float:right;"
                                                    class="animate-spin inline-block w-8 h-8 border-[3px] border-l-transparent border-violet-500 rounded-full">
                                                  </div> -->
<!--                                                         
                                                    <router-link :to="'/hiring-companies/' + jobListing.CompanyName + '/' + jobListing.Identifier" 
                                                        data-bs-toggle="modal">View <i class="mdi mdi-chevron-double-right"></i>
                                                      </router-link> -->
                                                  </div>
                                              </div>
                                              <!--end col-->

                                              <div class="col-span-12" style="padding: 0px 0px 20px;" 
                                                v-if="showMoreJobListing != null && showMoreJobListing.Identifier == jobListing.Identifier">
                                                <WysiwygViewer class="p-3 text-sm text-gray-900 dark:text-gray-50" :viewerText="this.showMoreJobListing.Description" />
                                                <p class="job-disclaimer p-3 text-gray-500 dark:text-gray-30" style="font-size: 12px;" >
                                                  This job summary is provided for informational purposes only and has been generated from publicly available sources. 
                                                  It may be incomplete or inaccurate. 
                                                  For full details and the official job description, please visit the employer’s original job posting.
                                                </p>
                                                <div class="">
                                                  <JobListingApplyButton 
                                                    style="float:right; margin-right: 20px;"
                                                    :jobListingIdentifier="jobListing.Identifier"/>

                                                  <button 
                                                  class="text-gray-700 dark:text-gray-50"
                                                    style="float: left; cursor: pointer; margin-top: 20px; margin-left: 20px;" 
                                                    @click.stop="handleJobListingShowMoreClick(jobListing.Identifier, this)">
                                                    <i class="mdi mdi-chevron-double-up"></i>
                                                  </button>
                                              </div>
                                            </div>
                                          </div>
                                          <!--end row-->
                                      </div>
                                </div>

                              <div class="mb-12">
                                <div class="grid grid-cols-1" v-if="this.jobListingResultCount >= this.pageSize">
                                    <div class="text-center">
                                      <Pagination v-if="this.jobListingResultCount !== 0"
                                        :totalPages="Math.ceil(jobListingResultCount / pageSize)"
                                        :perPage="pageSize"
                                        :currentPage="currentPage"
                                        @pagechanged="onPageChange" />
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
          </div>
      </section>
</div>


</template>

<script>
import { jobListingAPI } from "@/api/jobListing";
import { jobListingCategoryAPI } from "@/api/jobListingCategory";
import { useStatus } from "@/api/composables/status";
import { useErrorLogger } from "@/api/composables/errorLogging";
import WysiwygViewer from '@/components/WysiwygViewer.vue'
import Pagination from '@/components/Pagination.vue'
import FeedbackNotification from "@/components/FeedbackNotification.vue";
import JobListingApplyButton from "@/components/JobListingApplyButton.vue";
import EmailSubscriptionForm from "@/components/Forms/EmailSubscriptionForm.vue";
import Loader from "@/components/Loader.vue";
import SeoMeta from "@/components/Seo/SeoMeta.vue";

const pageStatus = useStatus();
const log = useErrorLogger();

export default {  
  name: "JobListingSearchView",
  components : {
    EmailSubscriptionForm, WysiwygViewer, FeedbackNotification, JobListingApplyButton, Pagination, Loader, SeoMeta
  }, 
  data() {
    return {
      notification : {
        text : "",
        level : "",
      },
      emSub: true,
      resetEmailForm: false,
      isApplicationSubmitted : false,
      search: { 
        keywords: this.$route.query.keywords !== undefined || this.$route.query.keywords != '' ? this.$route.query.keywords : null,
        workingStyle: this.$route.query.workingStyle !== undefined || this.$route.query.workingStyle != null ? this.$route.query.workingStyle : null,
        companyName: this.$route.query.companyName !== undefined ? this.$route.query.companyName : null,
        tags: this.$route.query.tags !== undefined ? this.$route.query.tags.length == 1 ? [this.$route.query.tags] : this.$route.query.tags : [],
        minSalary: this.$route.query.minSalary !== undefined ? this.$route.query.minSalary : null,
        location: this.$route.query.location !== undefined ? this.$route.query.location : null,
        contractType: this.$route.query.contractType !== undefined ? this.$route.query.contractType : null,
        sortOrder: this.$route.query.sortOrder !== undefined ? this.$route.query.sortOrder : null,
        pageNumber: this.$route.query.pageNumber !== undefined ? this.$route.query.pageNumber : null,
        pageSize: this.$route.query.pageSize !== undefined ? this.$route.query.pageSize : null
      },
      jobListingResultCount : 0,
      jobListingShowingCount : 0,
      jobListings : [],
      pageLoading : true,
      jobListingsLoading : true,
      jobListingCategories : [],
      salaryBrackets : [10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 110000, 120000],
      defaultSortOrder : ["BestMatch","Best Match"],
      sortOrders : [["RecentUpload","Recent Upload"],["HighestSalary","Highest Salary"],["LowestSalary","Lowest Salary"],["MostPopular","Most Popular"]],
      showMoreJobListing : null,
      currentPage: this.$route.query.pageNumber !== undefined ? this.$route.query.pageNumber : 1,
      pageSize: this.$route.query.pageSize !== undefined ? this.$route.query.pageSize : 50,
    };
  },
watch:{
    $route (to, from){
      if(to.fullPath == "/" && from.fullPath != "/")
      {
        this.resetSearch();
        this.handleJobListingSearch(true, "searchHint");      }
    }
},
 created()
 {
    this.getJobListingCategories();
    this.handleJobListingSearch(true, "");   
 },
  mounted() {
    document.title = 'Search Jobs - TheJobTap.com'
  },
  methods: {
    resetSearch(){
      this.search.sortOrder = null;
      this.search.keywords = null;
      this.search.tags = [];
      this.search.companyName = null;
      this.search.workingStyle = null;
      this.search.location = null;
      this.search.contractType = null;
      this.search.minSalary = null;
      this.search.pageNumber = null;
      this.search.pageSize = null;
    },
    scrollToElement(hintId) {   
      const element = document.getElementById(hintId);

      if (hintId == 'searchResultsHint' || hintId == 'searchHint'){
        const yOffset = -30; 
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({top: y});
      }
      // else if (hintId == 'searchHint'){
      //   const yOffset = -30; 
      //   const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      //   window.scrollTo({top: y, behavior: 'smooth'});
      // }
      else {      
        const yOffset = -75; 
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
      }
    },
    async createQueryString() {
      const query = Object.assign({}, this.$route.query);
      query.sortOrder = this.search.sortOrder == null ? [] : this.search.sortOrder;
      query.keywords = this.search.keywords == null ? [] : this.search.keywords;
      query.tags = this.search.tags;
      query.companyName = this.search.companyName == null ? [] : this.search.companyName;
      query.workingStyle = this.search.workingStyle == null ? [] : this.search.workingStyle;
      query.location = this.search.location == null ? [] : this.search.location;
      query.contractType = this.search.contractType == null ? [] : this.search.contractType;
      query.minSalary = this.search.minSalary == null ? [] : this.search.minSalary;
      query.pageNumber = this.search.pageNumber == null ? [] : this.search.pageNumber;
      query.pageSize = this.search.pageSize == null ? [] : this.search.pageSize;
      await this.$router.push({ query });
    },
    async onPageChange(pageNumber) {
      this.search.pageNumber = pageNumber;
      this.currentPage = pageNumber;
      this.jobListingShowingCount = pageNumber * this.pageSize;
      await this.handleJobListingSearch(false, "searchResultsHint");
    },
    resetPageNumber(){
      this.search.pageNumber = this.search.pageSize;
      this.currentPage = 1;
    },
    async handleSearchTermInput(keywords) {
      if(keywords == null)
      {
        this.search.keywords = keywords ;
      }
      await this.handleJobListingSearch(true, "searchResultsHint");
    },
    async handleSortOrderOnChange(event){
      this.search.sortOrder = event.target.value;
      await this.handleJobListingSearch(true, "searchResultsHint");
    },
    async handleLocationClick(location) {
      if(this.search.location == location){
        this.search.location = null;
      }
      else{
        this.search.location = location;
      }
      await this.handleJobListingSearch(true, "searchResultsHint");
    },
    async handleCompanyNameClick(companyName) {
      if(this.search.companyName == companyName){
        this.search.companyName = null;
      }
      else{
        this.search.companyName = companyName;
      }
      await this.handleJobListingSearch(true, "searchResultsHint");
    },
    async handleContractTypeClick(contractType) {
      if(this.search.contractType == contractType){
        this.search.contractType = null;
      }
      else{
        this.search.contractType = contractType;
      }
      await this.handleJobListingSearch(true, "searchResultsHint");
    },
    async handleSalaryOnChange(event){
      this.search.minSalary = event.target.value;
      await this.handleJobListingSearch(true);
    },
    async handleIsRemoteClick(attendanceRequirement, hintId) {
      if(attendanceRequirement == this.search.workingStyle)
      {
        this.search.workingStyle = null;
      }
      else
      {
        this.search.workingStyle = attendanceRequirement;
      }
      await this.handleJobListingSearch(true, hintId);
    },
    async handleCategoryClick(categoryName, hintId) {
      if (categoryName == null)
      {
         this.search.tags = [];
         await this.handleJobListingSearch(true, hintId);
         return;
      }
      if(!Array.isArray(this.search.tags))
      {
         const categoryNames = [];
         categoryNames.push(categoryName);
         if(this.search.tags){
            categoryNames.push(this.search.tags);
         }
         this.search.tags = categoryNames;
         await this.handleJobListingSearch(true, hintId);
         return;
      }
      const categoryNames = [];
      this.search.tags.forEach(element => {
        if (element != categoryName)
        {
          categoryNames.push(element);
        }
      });
      if (!this.search.tags.includes(categoryName))
      {
        categoryNames.push(categoryName);
      }
      this.search.tags = categoryNames;
      await this.handleJobListingSearch(true, hintId);
    },
    async viewJobListingPageClick(companyName, identifier) {
      this.$router.push('/hiring-companies/' + companyName + '/' + identifier + '/');
    },
    async getJobListingCategories() {
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await jobListingCategoryAPI.getCategories(true);
          this.jobListingCategories = result;
        })
      );
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }
    },
    async handleJobListingSearch(resetPageNumber, hint) 
    {
      this.emSub = false;

      if (resetPageNumber)
      {
        this.resetPageNumber();
      }

      if(this.search.workingStyle == 'null')
      {
        this.search.workingStyle = null
      }

      this.jobListingsLoading = true;

      if(!this.pageLoading && hint)
      {
        this.scrollToElement(hint)
      }
      this.notification.text = "";
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await jobListingAPI.search(this.search.tags, this.search.companyName, 
          this.search.workingStyle, this.search.minSalary, this.search.location, this.search.contractType, 
          this.search.keywords, this.search.sortOrder, this.pageSize, this.search.pageNumber);
              this.showMoreJobListing = null;
              this.jobListingResultCount = result.ResultCount;
              this.jobListingShowingCount = result.Results.length; 
              this.jobListings = result.Results;
              this.resetEmailForm = true;
              await this.createQueryString(hint);
              this.emSub = true;
              this.pageLoading = false;
        })
      );
      this.jobListingsLoading = false;

      if (this.jobListingResultCount === 0)
      {
        this.notification = { text : "No job listing results found for search criteria", level : "notification" };        
      }
      if (!result.success) {
          this.jobListingResultCount = 0;
          this.jobListingShowingCount = 0; 
          this.pageLoading = false;
          this.jobListings = null;
          this.notification = { text : result.data, level : "error" };        
      }
    },
    async handleJobListingShowMoreClick(identifier, e) {
      if (this.showMoreJobListing != null && this.showMoreJobListing.Identifier == identifier)
      {
        // minimise change..
        this.showMoreJobListing = null;
        this.scrollToElement(identifier);
        return;
      }
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await jobListingAPI.getByIdentifier(identifier);
          this.showMoreJobListing = result;
        })
      );
      this.scrollToElement(identifier);
      // loader stop
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }
    },
  },
};


</script>

